import {Injectable, Injector} from '@angular/core';
import {HttpService} from 'projects/core/src/public-api';
import {Observable} from 'rxjs';
import {Preset} from './preset';

@Injectable({
  providedIn: 'root'
})
export class PresetService extends HttpService {

  constructor(protected injector: Injector) {
    super(injector);
  }

  getPresets(): Observable<Preset[]> {
    return this.getData(`/presets`, Preset);
  }

  getPreset(id: number): Observable<Preset> {
    return this.getData(`/presets/${id}`, Preset);
  }

  createPreset(preset: Preset): Observable<Preset> {
    return this.postData(`/presets`, preset, Preset);
  }

  updatePreset(preset: Preset): Observable<Preset> {
    return this.putData(`/presets/update`, preset, Preset);
  }

  deletePreset(id: number): Observable<void> {
    return this.deleteData(`/presets/${id}`, Preset);
  }
}

